(function() { window.GUID_1a5de513_686f_4ea0_8d5c_ffca50cd1e0b = { getGuid: function() { return "1a5de513-686f-4ea0-8d5c-ffca50cd1e0b"; } }; })();
var CS;
(function (CS) {
    class DropDownV2 {
        constructor(dropDown) {
            this.LastKeyTimer = null;
            this.TempSelElement = null;
            this.isReadOnly = false;
            this.PrepareOnChange = function () {
                var me = this;
            };
            this.Text = function () {
                var me = this;
                if (me.DisplayedValue != null && me.DisplayedValue.length > 0) {
                    return me.DisplayedValue[0].innerHTML.replaceAll("<br>", "").replaceAll("&nbsp;", "");
                }
                else {
                    return "";
                }
            };
            this.Val = function () {
                var me = this;
                return me.HiddenVal.val();
            };
            this.Refresh = function () {
                var me = this;
            };
            this.OnElementClicked = function (clickedElement) {
                var me = this;
                me.SelectElementTemp(clickedElement);
            };
            this.OpenElementsList = function () {
                var me = this;
                var byPassIsVisibleCheck = false;
                if (IsDefined(typeof (document.LastDropDownOpened))) {
                    if (document.LastDropDownOpened.Id != me.Id) {
                        document.LastDropDownOpened.CloseElementsList(true);
                        byPassIsVisibleCheck = true;
                    }
                }
                if (byPassIsVisibleCheck == false && me.Elements.is(':visible')) {
                    return;
                }
                me.ElementsValues.removeClass('IsSelected');
                var selectedElement = me.FindSelectedElementInList();
                if (selectedElement != null) {
                    selectedElement.addClass('IsSelected');
                    me.TempSelElement = selectedElement;
                    me.SelectedElementBeforeOpen = selectedElement;
                }
                document.LastDropDownOpened = me;
                CS.body.off('keyup.' + me.Id);
                CS.body.off('keydown.' + me.Id);
                me.DisplayedValue.off('keydown.' + me.Id);
                var dropDownLayout = new CS.LayoutElement(me.DropDown);
                var blockKeyUp = false;
                var bodyLayout = new CS.LayoutElement(CS.body);
                var openDirection = 'down';
                if (bodyLayout && dropDownLayout.Top > bodyLayout.VMiddle) {
                    openDirection = 'up';
                }
                if (openDirection == "down") {
                    if (me.ExtendedContainer.html() != "") {
                        me.ExtendedContainer.css({
                            left: dropDownLayout.Left + 'px',
                            top: dropDownLayout.Bottom + 'px',
                            bottom: 'auto'
                            //width: me.DropDown.outerWidth() + 'px',
                        });
                    }
                }
                else if (openDirection == "up") {
                    if (me.ExtendedContainer.html() != "") {
                        me.ExtendedContainer.css({
                            left: dropDownLayout.Left + 'px',
                            top: 'auto',
                            bottom: bodyLayout.Bottom - dropDownLayout.Top + 'px'
                            //width: me.DropDown.outerWidth() + 'px'
                        });
                    }
                }
                var maxHeight = 0;
                me.ExtendedContainer.slideDown(50, function () {
                    if (me.ExtendedContainer.html() != "") {
                        CompuSport.Layout.PositionTargetRefToSourceAndWindows(me.ExtendedContainer, me.Elements);
                    }
                    else {
                        CompuSport.Layout.PositionTargetRefToSourceAndWindows(me.DropDown, me.Elements);
                    }
                    me.DisplayedValue.on('keydown.' + me.Id, function (e) {
                        if (e.keyCode == 13) {
                            e.preventDefault();
                            me.DisplayedValue.trigger('blur');
                        }
                        else {
                            me.OpenElementsList();
                        }
                    });
                    $(me.DropDown).trigger('beforeopen', me);
                    me.ExtendedContainer.off('click');
                    me.ExtendedContainer.on('click', function () {
                        me.CloseElementsList();
                        $(me.DropDown).trigger('extendclick', me);
                    });
                    me.DropDown.addClass('IsOpened');
                    me.Elements.slideDown(250, function () {
                        CS.on('keydown.' + me.Id, function (e) {
                            var actualSelElement = me.TempSelElement;
                            if (e.keyCode == 13 /*Enter*/) {
                                me.SelectElement(actualSelElement);
                                me.CloseElementsList();
                                e.preventDefault();
                                blockKeyUp = true;
                            }
                            else if (e.keyCode == 27) {
                                me.SelectElement(me.SelectedElementBeforeOpen);
                                me.CloseElementsList();
                                blockKeyUp = true;
                            }
                            else if (e.keyCode == 38 /*UP ARROW*/) {
                                if (actualSelElement != null) {
                                    var previousElement = actualSelElement.prevAll().not('.IsFiltered').first();
                                    if (previousElement != null && previousElement.length > 0) {
                                        me.SelectElementTemp(previousElement);
                                        e.preventDefault();
                                    }
                                }
                                else {
                                    me.SelectElementTemp($(me.ElementsValues[0]));
                                    e.preventDefault();
                                }
                                blockKeyUp = true;
                            }
                            else if (e.keyCode == 40 /*DOWN ARROW*/) {
                                if (actualSelElement != null) {
                                    var nextElement = actualSelElement.nextAll().not('.IsFiltered').first();
                                    if (nextElement != null && nextElement.length > 0) {
                                        me.SelectElementTemp(nextElement);
                                        e.preventDefault();
                                    }
                                }
                                else {
                                    me.SelectElementTemp($(me.ElementsValues[0]));
                                    e.preventDefault();
                                }
                                blockKeyUp = true;
                            }
                        }).on('keyup.' + me.Id, function (e) {
                            if (blockKeyUp) {
                                blockKeyUp = false;
                                return;
                            }
                            clearTimeout(me.LastKeyTimer);
                            me.LastKeyTimer = setTimeout(function () {
                                var text = $(e.target).val();
                                var actualText = text.replaceAll("<br>", "").replaceAll("&nbsp;", "").toLowerCase();
                                actualText = actualText.trim();
                                var isFirst = true;
                                for (var i = 0; i < me.ElementsCount; i++) {
                                    var element = me.ElementsValues[i];
                                    var $element = $(element);
                                    if (actualText == "" || element.innerHTML.toLowerCase().indexOf(actualText) > -1 || $element.data('val').toString().toLowerCase().indexOf(actualText) > -1) {
                                        $element.removeClass('IsFiltered');
                                        if (isFirst) {
                                            me.SelectElementTemp($element);
                                            isFirst = false;
                                        }
                                    }
                                    else {
                                        $element.addClass('IsFiltered');
                                    }
                                }
                            }, 250);
                        }).on('mousedown.' + me.Id, function (e) {
                            var target = $(e.target);
                            if (target.hasClass('DisplayedValue') || target.hasClass('CSDropDownElements')) {
                                return;
                            }
                            if (target.hasClass('DEle')) {
                                e.preventDefault();
                                me.OnElementClicked(target);
                                me.SelectElement(me.TempSelElement);
                            }
                            else if (target.hasClass('ExtendedContainer') || target.closest('.ExtendedContainer').length > 0) {
                                return;
                            }
                            me.CloseElementsList();
                        });
                    });
                });
            };
            this.CloseElementsList = function (directClose) {
                var me = this;
                var speed = 50;
                if (directClose != null) {
                    speed = 0;
                }
                me.ExtendedContainer.slideUp(speed);
                me.Elements.slideUp(speed);
                CS.off('keydown.' + me.Id);
                CS.off('keyup.' + me.Id);
                CS.off('mousedown.' + me.Id);
                me.ElementsValues.removeClass('IsFiltered');
                me.CancelSelectionIfNecessary();
                me.DropDown.removeClass('IsOpened');
            };
            this.SelectElement = function (element) {
                var me = this;
                if (element == null) {
                    return;
                }
                me.ElementsValues.removeClass('IsSelected');
                var newEId = element[0].id.replace('EId', '');
                if (me.HiddenVal.val() != newEId) {
                    me.HiddenVal.val(newEId);
                    me.DisplayedValue.html(element.data('val'));
                    $(me.DropDown).trigger('change', me);
                }
            };
            this.CancelSelectionIfNecessary = function () {
                var me = this;
                var lastSelectedElement = me.FindSelectedElementInList();
                if (lastSelectedElement != null) {
                    me.DisplayedValue.html(lastSelectedElement.data('val'));
                }
            };
            this.FindSelectedElementInList = function () {
                var me = this;
                var actualSelectedId = "EId" + me.HiddenVal.val();
                var end = me.ElementsValues.length;
                for (var i = 0; i < end; i++) {
                    if (actualSelectedId == me.ElementsValues[i].id) {
                        return $(me.ElementsValues[i]);
                    }
                }
                return null;
            };
            this.SelectElementTemp = function (element) {
                var me = this;
                me.ElementsValues.removeClass('IsSelected');
                me.TempSelElement = element;
                me.TempSelElement.addClass('IsSelected');
            };
            this.ReplacementElementsWithNewList = function (newElements) {
                var me = this;
                var $element = $('<div>');
                $element.append(newElements);
                var classToFind = '.EleKey' + me.ElementsKey;
                var $newElements = $(classToFind, $element).children();
                var elements = CS.body.children(classToFind + '.IsInBody');
                if (elements.length > 0) {
                    elements.children().remove();
                }
                elements.append($newElements);
            };
            this.AppendElementToBody = function (classToFind) {
                var notInBody = $(classToFind).not('.IsInBody');
                /*Cette passe la evite un doublon de la liste*/
                if (notInBody.length > 0) {
                    var elements = CS.body.children(classToFind + '.IsInBody');
                    if (elements.length > 0) {
                        elements.remove();
                    }
                    notInBody.detach().appendTo('body');
                    notInBody.addClass('IsInBody');
                    return notInBody;
                }
                else {
                    return $(classToFind);
                }
            };
            this.uiDiscovery(dropDown);
            if (!this.isReadOnly) {
                this.bindEvent();
            }
        }
        uiDiscovery(dropDown) {
            this.Id = dropDown[0].id;
            this.HiddenVal = $('input[type=hidden]', dropDown);
            this.LastKeyTimer = null;
            this.TempSelElement = null;
            this.DropDown = dropDown;
            this.ElementsKey = dropDown.data('elementskey');
            this.DropDown.data('context', this);
            this.isReadOnly = this.DropDown.hasClass('IsReadOnly');
            if (this.isReadOnly) {
                return;
            }
            this.SelectedElementBeforeOpen = null;
            this.DisplayedValue = $('.DisplayedValue', this.DropDown);
            /*##########################################################################*/
            /*Laisser ça la, sinon, ca fait peter la scoresheetlive, ce sera bon d'améliorer ça*/
            this.DisplayedValue.on('keyup change', function (e) {
                e.preventDefault();
                e.stopPropagation();
            });
            /*##########################################################################*/
            let selEId = this.HiddenVal.val();
            let dropDownClicked = false;
            this.Elements = this.AppendElementToBody('.EleKey' + this.ElementsKey);
            this.ExtendedContainer = this.AppendElementToBody('.ExtKey' + this.ElementsKey);
            let refCount = this.Elements.data('refcount');
            this.Elements.data('refcount', refCount + 1);
            this.ElementsValues = this.Elements.children('.DEle');
            this.ElementsCount = this.ElementsValues.length;
        }
        bindEvent() {
            let me = this;
            this.DropDown.on('mousedown', function (e) {
                me.OpenElementsList();
            });
            CS.win.resize(function () {
                me.CloseElementsList();
            });
            CS.on('touchmove', function (e) {
                if (!$(e.target).hasClass('DEle')) {
                    if (me.Elements.is(':visible')) {
                        me.CloseElementsList();
                    }
                }
            });
            CS.on('popup.closed.dropdownv2', function (e, data) {
                if (IsDefined(typeof (this.DropDown))) { /*Je sais étrange, mais ca l'arrive :)*/
                    if (this.DropDown.closest(data.formDialog).length == 1) {
                        var refCount = me.Elements.data('refcount');
                        if (refCount <= 1) {
                            me.Elements.remove();
                            me.ExtendedContainer.remove();
                        }
                        else {
                            me.Elements.data('refcount', refCount - 1);
                        }
                        CS.off('popup.closed.dropdownv2');
                    }
                }
            });
        }
    }
    CS.DropDownV2 = DropDownV2;
})(CS || (CS = {}));
/*(function ($) {
    $.fn.CSDropDownV2 = function () {
        this.each(function () {
            var dropdown = new CS.DropDownV2($(this));
        });
    };
})(jQuery);


var CS = CS || {};
*/
//CS.DropDownV2 = function (dropDown) {
//    var me = this;
//    this.Id = dropDown[0].id;
//    me.HiddenVal = $('input[type=hidden]', dropDown);
//    me.LastKeyTimer = null;
//    me.TempSelElement = null;
//    me.DropDown = dropDown;
//    me.ElementsKey = dropDown.data('elementskey');
//    var isReadOnly = false;
//    isReadOnly = me.DropDown.hasClass('IsReadOnly');
//    if (isReadOnly)
//        return;
//    me.SelectedElementBeforeOpen = null;
//    me.DisplayedValue = $('.DisplayedValue', me.DropDown);
//    /*##########################################################################*/
//    /*Laisser ça la, sinon, ca fait peter la scoresheetlive, ce sera bon d'améliorer ça*/
//    me.DisplayedValue.on('keyup change', function (e) {
//        e.preventDefault();
//        e.stopPropagation();
//    });
//    /*##########################################################################*/
//    var selEId = me.HiddenVal.val();
//    var dropDownClicked = false;
//    me.Elements = me.AppendElementToBody('.EleKey' + me.ElementsKey);
//    me.ExtendedContainer = me.AppendElementToBody('.ExtKey' + me.ElementsKey);
//    var refCount = me.Elements.data('refcount');
//    me.Elements.data('refcount', refCount + 1);
//    me.ElementsValues = me.Elements.children('.DEle');
//    me.ElementsCount = me.ElementsValues.length;
//    dropDown.on('mousedown', function (e) {
//        me.OpenElementsList();
//    });
//    CS.win.resize(function () {
//        me.CloseElementsList();
//    });
//    CS.on('touchmove', function (e) {
//        if (!$(e.target).hasClass('DEle')) {
//            if (me.Elements.is(':visible')) {
//                me.CloseElementsList();
//            }
//        }
//    });
//    CS.on('popup.closed.dropdownv2', function (e, data) {
//        if (dropDown.closest(data.formDialog).length == 1) {
//            var refCount = me.Elements.data('refcount');
//            if (refCount <= 1) {
//                me.Elements.remove();
//                me.ExtendedContainer.remove();
//            }
//            else {
//                me.Elements.data('refcount', refCount - 1);
//            }
//            CS.off('popup.closed.dropdownv2');
//        }
//    });
//};
//CS.DropDownV2.prototype = function () {
//    var PrepareOnChange = function () {
//        var me = this;
//    },
//    Text = function () {
//        var me = this;
//        if (me.DisplayedValue != null && me.DisplayedValue.length > 0) {
//            return me.DisplayedValue[0].innerHTML.replaceAll("<br>", "").replaceAll("&nbsp;", "");
//        }
//        else {
//            return "";
//        }
//    },
//    Val = function () {
//        var me = this;
//        return me.HiddenVal.val();
//    },
//    Refresh = function () {
//        var me = this;
//    },
//    OnElementClicked = function (clickedElement) {
//        var me = this;
//        me.SelectElementTemp(clickedElement);
//    },
//    OpenElementsList = function () {
//        var me = this;
//        var byPassIsVisibleCheck = false;
//        if (IsDefined(typeof (document.LastDropDownOpened))) {
//            if (document.LastDropDownOpened.Id != me.Id) {
//                document.LastDropDownOpened.CloseElementsList(true);
//                byPassIsVisibleCheck = true;
//            }
//        }
//        if (byPassIsVisibleCheck == false && me.Elements.is(':visible')) {
//            return;
//        }
//        me.ElementsValues.removeClass('IsSelected');
//        var selectedElement = me.FindSelectedElementInList();
//        if (selectedElement != null) {
//            selectedElement.addClass('IsSelected');
//            me.TempSelElement = selectedElement;
//            me.SelectedElementBeforeOpen = selectedElement;
//        }
//        document.LastDropDownOpened = me;
//        CS.body.off('keyup.' + me.Id);
//        CS.body.off('keydown.' + me.Id);
//        me.DisplayedValue.off('keydown.' + me.Id);
//        var dropDownLayout = new CS.LayoutElement(me.DropDown);
//        var blockKeyUp = false;
//        var bodyLayout = new CS.LayoutElement(CS.body);
//        var openDirection = 'down';
//        if (dropDownLayout.Top > bodyLayout.VMiddle) {
//            openDirection = 'up';
//        }
//        if (openDirection == "down") {
//            if (me.ExtendedContainer.html() != "") {
//                me.ExtendedContainer.css({
//                    left: dropDownLayout.Left + 'px',
//                    top: dropDownLayout.Bottom + 'px',
//                    bottom: 'auto'
//                    //width: me.DropDown.outerWidth() + 'px',
//                });
//            }
//        }
//        else if (openDirection == "up") {
//            if (me.ExtendedContainer.html() != "") {
//                me.ExtendedContainer.css({
//                    left: dropDownLayout.Left + 'px',
//                    top: 'auto',
//                    bottom: bodyLayout.Bottom - dropDownLayout.Top + 'px'
//                    //width: me.DropDown.outerWidth() + 'px'
//                });
//            }
//        }
//        var maxHeight = 0;
//        me.ExtendedContainer.slideDown(50, function () {
//            if (me.ExtendedContainer.html() != "") {
//                CompuSport.Layout.PositionTargetRefToSourceAndWindows(me.ExtendedContainer, me.Elements);
//            }
//            else
//            {
//                CompuSport.Layout.PositionTargetRefToSourceAndWindows(me.DropDown, me.Elements);
//            }
//            me.DisplayedValue.on('keydown.' + me.Id, function (e) {
//                if (e.keyCode == 13) {
//                    e.preventDefault();
//                    me.DisplayedValue.trigger('blur');
//                }
//                else {
//                    me.OpenElementsList();
//                }
//            });
//            $(me.DropDown).trigger('beforeopen', me);
//            me.ExtendedContainer.off('click');
//            me.ExtendedContainer.on('click', function () {
//                me.CloseElementsList();
//                $(me.DropDown).trigger('extendclick', me);
//            });
//            me.DropDown.addClass('IsOpened');
//            me.Elements.slideDown(250, function () {
//                CS.on('keydown.' + me.Id, function (e) {
//                    var actualSelElement = me.TempSelElement;
//                    if (e.keyCode == 13 /*Enter*/) {
//                        me.SelectElement(actualSelElement);
//                        me.CloseElementsList();
//                        e.preventDefault();
//                        blockKeyUp = true;
//                    }
//                    else if (e.keyCode == 27) {
//                        me.SelectElement(me.SelectedElementBeforeOpen);
//                        me.CloseElementsList();
//                        blockKeyUp = true;
//                    }
//                    else if (e.keyCode == 38 /*UP ARROW*/) {
//                        if (actualSelElement != null) {
//                            var previousElement = actualSelElement.prevAll().not('.IsFiltered').first();
//                            if (previousElement != null && previousElement.length > 0) {
//                                me.SelectElementTemp(previousElement);
//                                e.preventDefault();
//                            }
//                        }
//                        else {
//                            me.SelectElementTemp($(me.ElementsValues[0]));
//                            e.preventDefault();
//                        }
//                        blockKeyUp = true;
//                    }
//                    else if (e.keyCode == 40/*DOWN ARROW*/) {
//                        if (actualSelElement != null) {
//                            var nextElement = actualSelElement.nextAll().not('.IsFiltered').first();
//                            if (nextElement != null && nextElement.length > 0) {
//                                me.SelectElementTemp(nextElement);
//                                e.preventDefault();
//                            }
//                        }
//                        else {
//                            me.SelectElementTemp($(me.ElementsValues[0]));
//                            e.preventDefault();
//                        }
//                        blockKeyUp = true;
//                    }
//                }).on('keyup.' + me.Id, function (e) {
//                    if (blockKeyUp) {
//                        blockKeyUp = false;
//                        return;
//                    }
//                    clearTimeout(me.LastKeyTimer);
//                    me.LastKeyTimer = setTimeout(function () {
//                        var text = $(e.target).val();
//                        var actualText = text.replaceAll("<br>", "").replaceAll("&nbsp;", "").toLowerCase();
//                        actualText = actualText.trim();
//                        var isFirst = true;
//                        for (var i = 0; i < me.ElementsCount; i++) {
//                            var element = me.ElementsValues[i];
//                            var $element = $(element);
//                            if (actualText == "" || element.innerHTML.toLowerCase().indexOf(actualText) > -1 || $element.data('val').toString().toLowerCase().indexOf(actualText) > -1) {
//                                $element.removeClass('IsFiltered');
//                                if (isFirst) {
//                                    me.SelectElementTemp($element);
//                                    isFirst = false;
//                                }
//                            }
//                            else {
//                                $element.addClass('IsFiltered');
//                            }
//                        }
//                    }, 250);
//                }).on('mousedown.' + me.Id, function (e) {
//                    var target = $(e.target);
//                    if (target.hasClass('DisplayedValue') || target.hasClass('CSDropDownElements'))
//                        return;
//                    if (target.hasClass('DEle')) {
//                        e.preventDefault();
//                        me.OnElementClicked(target);
//                        me.SelectElement(me.TempSelElement);
//                    }
//                    else if (target.hasClass('ExtendedContainer') || target.closest('.ExtendedContainer').length > 0) {
//                        return;
//                    }
//                    me.CloseElementsList();
//                });
//            });
//        });
//    },
//    CloseElementsList = function (directClose) {
//        var me = this;
//        var speed = 50;
//        if (directClose != null) {
//            speed = 0;
//        }
//        me.ExtendedContainer.slideUp(speed);
//        me.Elements.slideUp(speed);
//        CS.off('keydown.' + me.Id);
//        CS.off('keyup.' + me.Id);
//        CS.off('mousedown.' + me.Id);
//        me.ElementsValues.removeClass('IsFiltered');
//        me.CancelSelectionIfNecessary();
//        me.DropDown.removeClass('IsOpened');
//    },
//    SelectElement = function (element) {
//        var me = this;
//        if (element == null)
//            return;
//        me.ElementsValues.removeClass('IsSelected');
//        var newEId = element[0].id.replace('EId', '');
//        if (me.HiddenVal.val() != newEId) {
//            me.HiddenVal.val(newEId);
//            me.DisplayedValue.html(element.data('val'));
//            $(me.DropDown).trigger('change', me);
//        }
//    },
//    CancelSelectionIfNecessary = function () {
//        var me = this;
//        var lastSelectedElement = me.FindSelectedElementInList();
//        if (lastSelectedElement != null) {
//            me.DisplayedValue.html(lastSelectedElement.data('val'));
//        }
//    },
//    FindSelectedElementInList = function () {
//        var me = this;
//        var actualSelectedId = "EId" + me.HiddenVal.val();
//        var end = me.ElementsValues.length;
//        for (var i = 0; i < end; i++) {
//            if (actualSelectedId == me.ElementsValues[i].id) {
//                return $(me.ElementsValues[i]);
//            }
//        }
//        return null;
//    },
//    SelectElementTemp = function (element) {
//        var me = this;
//        me.ElementsValues.removeClass('IsSelected');
//        me.TempSelElement = element;
//        me.TempSelElement.addClass('IsSelected');
//    },
//    ReplacementElementsWithNewList = function (newElements) {
//        var me = this;
//        var $element = $('<div>');
//        $element.append(newElements);
//        var classToFind = '.EleKey' + me.ElementsKey;
//        var $newElements = $(classToFind, $element).children();
//        var elements = CS.body.children(classToFind + '.IsInBody');
//        if (elements.length > 0)
//            elements.children().remove();
//        elements.append($newElements);
//    },
//     AppendElementToBody = function (classToFind) {
//         var notInBody = $(classToFind).not('.IsInBody');
//         /*Cette passe la evite un doublon de la liste*/
//         if (notInBody.length > 0) {
//             var elements = CS.body.children(classToFind + '.IsInBody');
//             if (elements.length > 0)
//                 elements.remove();
//             notInBody.detach().appendTo('body');
//             notInBody.addClass('IsInBody');
//             return notInBody;
//         }
//         else {
//             return $(classToFind);
//         }
//     };
//    return {
//        PrepareOnChange: PrepareOnChange,
//        Refresh: Refresh,
//        Val: Val,
//        Text: Text,
//        OnElementClicked: OnElementClicked,
//        SelectElement: SelectElement,
//        SelectElementTemp: SelectElementTemp,
//        OpenElementsList: OpenElementsList,
//        CloseElementsList: CloseElementsList,
//        FindSelectedElementInList: FindSelectedElementInList,
//        CancelSelectionIfNecessary: CancelSelectionIfNecessary,
//        ReplacementElementsWithNewList: ReplacementElementsWithNewList,
//        AppendElementToBody: AppendElementToBody
//    };
//}();

//# sourceMappingURL=cs.dropdownv2.js.map
